import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 500,
      fontSize: '0.875rem',
      backgroundColor: palette.background.box,
      boxShadow: palette.shadows.boxShadow,
      borderRadius: palette.borderRadius.default,
      padding: '7.5px 10px 7.5px 10px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: 'max-content',
      '@media (min-width: 1200px)': {
        width: 'auto'
      }
    },
    filtersBoxes: {
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
      userSelect: 'none',
      paddingRight: '10px',
      flexShrink: 0,
      '@media (min-width: 1200px)': {
        flexWrap: 'wrap',
        flexShrink: 1
      }
    },
    filterBox: {
      background: palette.common.primaryBlue,
      color: palette.text.white,
      borderRadius: palette.borderRadius.default,
      padding: '2.5px 5px 2.5px 5px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
